import { jsxs, jsx } from 'react/jsx-runtime';
import { Space } from '@sravni/react-design-system';
import { StarFilled, Message } from '@sravni/react-icons';
import { WithIcon } from '../WithIcon/WithIcon.js';
import modules_7b60ba63 from './Rating.module.scss.js';

var Rating = function (_a) {
    var rating = _a.rating, reviews = _a.reviews;
    return (jsxs(Space, { size: 4, direction: "vertical", inline: true, align: "end", children: [jsx(WithIcon, { icon: jsx(StarFilled, {}), text: rating.toString(), color: "orange" }), jsx(WithIcon, { icon: jsx(Message, {}), text: reviews.toString(), className: modules_7b60ba63.comments })] }));
};

export { Rating };
//# sourceMappingURL=Rating.js.map
